import { useRecoilValue } from 'recoil';
import { authState } from '../api';
import { Navigate } from 'react-router-dom';

export const PrivateRoute = ({ children, requireSignIn }: { children: React.ReactNode; requireSignIn?: boolean }) => {
  const authStateValue = useRecoilValue(authState);
  return requireSignIn && !authStateValue.refreshToken ? <Navigate to="/auth/login" /> : children;
};

export const MustLogoutRoute = ({ children }: { children: JSX.Element }) => {
  const authStateValue = useRecoilValue(authState);
  return authStateValue.refreshToken ? <Navigate to="/" /> : children;
};
